import { PrimaryLanguageEnum } from 'domains/client';
import { SIGNUP_CONCERNS_ADULT, SIGNUP_CONCERNS_PEDIATRIC } from 'domains/signupDirect/misc/communicationConcerns';
import {
  OTHER_INSURANCE_OPTION,
  SIGNUP_PRIVATE_PAY_OPTION,
  TherapyTargetValue,
} from 'domains/signupDirect/misc/constants';
import { getInsuranceV2Options } from 'domains/signupDirect/misc/insuranceOptions';
import { DirectSignupFiltersFormType, directSignupFiltersSchema } from 'domains/signupDirect/schemas/filtersSchema';
import { StateAbbrev } from 'utils/states';

export const extractFiltersFromURL = async (search: string): Promise<DirectSignupFiltersFormType | undefined> => {
  const params = new URLSearchParams(search);

  const therapyTarget = params.get('therapyTarget') || undefined;
  const stateCode = params.get('state') || undefined;
  const clinicalConcerns = params.get('clinicalConcerns') || undefined;
  const paymentMethod = params.get('paymentMethod') || undefined;

  const result: Partial<DirectSignupFiltersFormType> = {
    therapyTarget: therapyTarget as TherapyTargetValue,
    clinicalConcernKeys: [],
    stateCode: stateCode as StateAbbrev,
    language: PrimaryLanguageEnum.English, // Assume english for now
  };

  // Payment method
  if (paymentMethod === SIGNUP_PRIVATE_PAY_OPTION) {
    result.paymentMethod = {
      type: 'privatePay',
      id: SIGNUP_PRIVATE_PAY_OPTION,
    };
  } else if (paymentMethod === OTHER_INSURANCE_OPTION) {
    result.paymentMethod = {
      type: 'otherInsurance',
      id: OTHER_INSURANCE_OPTION,
    };
  } else {
    const insuranceData = await getInsuranceV2Options();

    const matchedInsurance = insuranceData.find(insurance => insurance.entryId === paymentMethod);
    if (matchedInsurance) {
      result.paymentMethod = {
        type: 'insurance',
        id: matchedInsurance.entryId,
        insuranceData: matchedInsurance,
      };
    }
  }

  // Clinical concerns

  if (clinicalConcerns) {
    clinicalConcerns.split(',').forEach(concernId => {
      const matchedConcernKey =
        SIGNUP_CONCERNS_PEDIATRIC.find(c => c.id === concernId) || SIGNUP_CONCERNS_ADULT.find(c => c.id === concernId);
      if (matchedConcernKey) result.clinicalConcernKeys?.push(matchedConcernKey.key);
    });
  }

  const parsedForm = directSignupFiltersSchema.safeParse({
    ...result,
  });

  if (parsedForm.success) {
    return parsedForm.data as DirectSignupFiltersFormType;
  }

  // If data doesn't pass validation, start from 0
  return undefined;
};
